/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RunTestRequest } from '../../models/run-test-request';

export interface ApiAdminApiTestsRunPost$Params {
      body?: RunTestRequest
}

export function apiAdminApiTestsRunPost(http: HttpClient, rootUrl: string, params?: ApiAdminApiTestsRunPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAdminApiTestsRunPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as HealthFindrStrictHttpResponse<void>;
    })
  );
}

apiAdminApiTestsRunPost.PATH = '/api/Admin/ApiTests/Run';
